import { faUndo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import { ETAPA_ASSISTENCIA_TECNICA } from "../../../../Constants/AssistenciaTecnica/EtapaTipoCaso";
import MarcarAtendimentoComoRecorrente from "./MarcarAtendimentoComoRecorrente";

interface IButtonAtendimentoRecorrenteProps {
    ID_CASO: number;
    ID_ETAPA_TIPO_CASO: number;
    setModal(modal: IComponentModal): void;
    setShow(show: boolean): void;
}

export default function ButtonAtendimentoRecorrente(
    props: IButtonAtendimentoRecorrenteProps
) {
    if (
        [
            ETAPA_ASSISTENCIA_TECNICA.AVALIACAO_DE_PROCEDENCIA.NR_ETAPA,
            ETAPA_ASSISTENCIA_TECNICA.AGENDAMENTO_VISTORIA_INICIAL.NR_ETAPA,
            ETAPA_ASSISTENCIA_TECNICA.AGENDAR_MANUTENCAO.NR_ETAPA,
        ].some((idEtapa) => idEtapa === props.ID_ETAPA_TIPO_CASO)
    ) {
        return (
            <button
                type="button"
                className="btn btn-sm d-flex align-items-center g-2 btn-shadow btn-info m-1"
                onClick={async () => {
                    props.setModal({
                        Component: () => (
                            <MarcarAtendimentoComoRecorrente
                                setShow={props.setShow}
                                ID_CASO={props.ID_CASO}
                            />
                        ),
                        headerComponent: "Atendimento Recorrente",
                        IconHeader: faUndo,
                    });
                    props.setShow(true);
                }}
            >
                <FontAwesomeIcon icon={faUndo} />
                Atendimento Recorrente
            </button>
        );
    } else return null;
}
